
<b-container>
  <!-- TODO: Change options later -->
  <b-modal
    size="xl"
    :visible="selectProductModal !== null"
    :title="`Select meal for ${showSlotTime(selectedDateTime)}`"
    ok-title="Save"
    dialog-class="modal-fullscreen-sm-down"
    @hidden="$emit('update-modal', false)"
    @ok="confirm"
  >
    <b-row v-if="loading" align-h="center">
      <SmallSpinner :size="50" centered />
    </b-row>
    <b-list-group v-else>
      <RotatingSubscriptionProduct
        v-for="(product, index) in products"
        :key="index"
        :product="product"
        :selected="isSelected(product)"
        @product-selected="handleProductSelection"
        @update-modifiers="updateModifiers"
      />
    </b-list-group>
  </b-modal>
</b-container>
